import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import AuthModal from '../AuthModal/AuthModal';
import './Account.css';

/** Pages a sign-in link may send the shopper back to; anything else goes to the profile. */
const RETURN_PATHS = new Set(['/checkout', '/wishlist']);

export default function AuthPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const status = useAuthStore((state) => state.status);
  const next = new URLSearchParams(location.search).get('next') ?? '';
  const destination = RETURN_PATHS.has(next) ? next : '/profile';
  if (status === 'authed') return <Navigate to={destination} replace />;
  return (
    <section className="account-page page-container">
      <h1>Login / signup</h1>
      <AuthModal onClose={() => navigate(destination, { replace: true })} />
    </section>
  );
}
